import requests from "./requests";
import config from "@shared/config/client";
import {
  withAuthenticatedClientRequest,
  withClientRequest,
} from "../requestBuilder/withClientRequest";
import { ICallableRequestBuilder } from "../requestBuilder/types";

const toggleFollow =
  (request: ICallableRequestBuilder<void>) => (foloweeId: string) => {
    return request.call(`${config.apiUrl}/follows/${foloweeId}`, (init) => ({
      ...init,
      method: "POST",
    }));
  };

const clientRequests = {
  getFolloweesByUser: withClientRequest(requests.getFolloweesByUser),
  getFollowersByUser: withClientRequest(requests.getFollowersByUser),
  getFollowersCount: withClientRequest(requests.getFollowersCount),
  getFollowingCount: withClientRequest(requests.getFollowingCount),
  toggleFollow: withAuthenticatedClientRequest(toggleFollow),
};

export default clientRequests;
